import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/log`

export const GetByText = async (token, text, actionGroup) => {
  const params = new URLSearchParams();
  if (text) {
    params.set("text", text);
  }
  if (actionGroup) {
    params.set("action_group", actionGroup);
  }
  const response = await axios.get(`${API_URL}/get_by_text/?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};
